import { AllEventsAnalyticsTotalsSnapshotSchema } from "@redotech/redo-model/analytics/analytics";
import z from "zod/v4";

export const getAllEventsAnalytics = {
  name: "getAllEventsAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
  }),
  output: z.object({
    current: z.array(AllEventsAnalyticsTotalsSnapshotSchema),
    previous: z.array(AllEventsAnalyticsTotalsSnapshotSchema),
    totalCount: z.number().optional(),
  }),
};
